module.exports = __webpack_public_path__ + "img/0d57387a33f86296e3d374049955b833.png";